import { useState, useEffect } from 'react';
import { useCurrentUserState } from '@src/shared/context/current-user';

const useStorageLayer = () => {
  const [initialAuthCheckDone, setInitialAuthCheckDone] =
    useState<boolean>(false);
  const { isProductOverviewSeen } = useCurrentUserState();

  useEffect(() => {
    setInitialAuthCheckDone(true);
  }, []);

  return {
    initialAuthCheckDone,
    isProductOverviewSeen,
  };
};

export default useStorageLayer;
